import { render, staticRenderFns } from "./SiteBatimentsList.vue?vue&type=template&id=ae171dfe&scoped=true&"
import script from "./SiteBatimentsList.vue?vue&type=script&lang=js&"
export * from "./SiteBatimentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae171dfe",
  null
  
)

export default component.exports